module.exports = __webpack_public_path__ + "static/img/banner-液压支架辅助安装机器人.e2495b03.webp";